import axios from 'axios';
import { setCorruptedUploadFields } from '../helpers/corruptedUpload';

const instance = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/${
    import.meta.env.VITE_API_VERSION
  }/`,
  withCredentials:
    import.meta.env.VITE_CSRF_PROTECTION === 'true' ? true : false,
});

export const fetchCsrfToken = async () => {
  try {
    const response = await instance.get('csrf-token');
    return response.data.csrfToken;
  } catch (error) {
    console.error('Error fetching CSRF token:', error);
    throw error;
  }
};

instance.interceptors.request.use(
  async (config) => {
    // Skip CSRF token fetch for the csrf-token endpoint itself
    if (config.url === 'csrf-token') {
      return config;
    }

    // A new upload clears the previous "corrupted file" field errors.
    if (config.data instanceof FormData) {
      setCorruptedUploadFields([]);
    }

    const token = localStorage.getItem('adminToken');
    config.headers.Authorization = token ? `Bearer ${token}` : '';

    // Add CSRF token for POST, PUT, PATCH, DELETE requests
    if (
      import.meta.env.VITE_CSRF_PROTECTION === 'true' &&
      ['post', 'put', 'patch', 'delete'].includes(config.method.toLowerCase())
    ) {
      // Fetch a fresh CSRF token for every mutating request
      const csrfToken = await fetchCsrfToken();
      config.headers['X-CSRF-Token'] = csrfToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Most sagas only read `errors`, which a CORRUPTED_FILE response does not
// have, so record the rejected fields for the pages to show inline.
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error?.response?.data;
    if (data?.errorCode === 'CORRUPTED_FILE') {
      setCorruptedUploadFields(data.fields);
    }
    return Promise.reject(error);
  }
);

export default instance;
